import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarComponent } from '../avatar/avatar.component';
import { ComponentSize } from '../types';

export interface AvatarItem {
  src?: string;
  label: string;
  alt?: string;
}

@Component({
  selector: 'app-avatar-group',
  imports: [CommonModule, AvatarComponent],
  template: `
    <div class="flex items-center -space-x-2">
      @for (avatar of visibleAvatars(); track $index) {
        <app-avatar
          [src]="avatar.src || ''"
          [label]="avatar.label"
          [alt]="avatar.alt || ''"
          [size]="size()"
          [shape]="shape()" />
      }
      @if (remainingCount() > 0) {
        <div [class]="overflowClasses">
          +{{ remainingCount() }}
        </div>
      }
    </div>
  `,
  styles: []
})
export class AvatarGroupComponent {
  avatars = input<AvatarItem[]>([]);
  maxVisible = input<number>(3);
  size = input<ComponentSize>('md');
  shape = input<'circle' | 'square'>('circle');

  visibleAvatars(): AvatarItem[] {
    return this.avatars().slice(0, this.maxVisible());
  }

  remainingCount(): number {
    return Math.max(0, this.avatars().length - this.maxVisible());
  }

  get overflowClasses(): string {
    const sizeMap = {
      xs: 'w-6 h-6 text-xs',
      sm: 'w-8 h-8 text-xs',
      md: 'w-10 h-10 text-sm',
      lg: 'w-12 h-12 text-base',
      xl: 'w-16 h-16 text-lg'
    };

    return [
      'flex',
      'items-center',
      'justify-center',
      'rounded-full',
      'bg-gray-200',
      'dark:bg-gray-700',
      'text-gray-600',
      'dark:text-gray-400',
      'font-semibold',
      'border-2',
      'border-white',
      'dark:border-gray-800',
      sizeMap[this.size()]
    ].join(' ');
  }
}

